

document.addEventListener("DOMContentLoaded", () => {
    function removeHairlines() {
        let contentSections = document.querySelectorAll('.article-wrap > section, #main section.colour-scheme');
        contentSections.forEach(el => {
            const prev = el.previousElementSibling;
            if (prev) {
                el.classList.add('u-kill-hairline');
            }
        });
    }
    removeHairlines();
});